import _ from 'lodash'
import axios from 'axios'
// import { Message } from 'ant-design-vue'
import router from '../router/index'
import indexConfig from "@/config/url.config.js";
import util from '@/views/CommonUtil.js'
// var _authHeader

export default class BaseAPI {
    static _authHeader

    constructor (options) {
      this._axios = axios.create({
        method: 'post',
        headers: { 'Content-Type': 'application/json;charset=UTF-8' },
        responseType: 'json',
        timeout: 10000,
        ...options
      })

      let ROOT = indexConfig.baseUrl+'/api/v1'
      // if (process.env.NODE_ENV === 'development') {
      //   ROOT = '/api/v1'
      // } else {
      //   ROOT = indexConfig.baseURL+'/api/v1'
      // }

      this.baseURL = ROOT

      let certificate = localStorage.getItem('user_certificate')
      if (certificate) {
        certificate = JSON.parse(certificate)
        this._authHeader = { Authorization: 'Bearer ' + certificate.access_token}
      }
    }

    get authHeader () {
      return this._authHeader
    }

    setAuthInfo (token) {
      this._authHeader = {
        Authorization: 'Bearer ' + token
      }
    }

    clearAuthInfo () {
		this._authHeader = null
		util.stopWebSocket()
    }

    requestWithAuth (url, args, conf) {
      // if (!this._authHeader) {
      //   return Promise.resolve(null)
      // }

      if (!conf.headers) {
        conf.headers = {}
      }
      _.assign(conf.headers, this._authHeader)
      return this.request(url, args, conf)
    }

    request (url, args, conf) {
      let config = {
        url: `${this.baseURL}${url}`,
        method: conf.method || 'get',
        data: args || {},
        headers: conf.headers || {}
      }

      if (this._authHeader) {
        _.assign(config.headers, this._authHeader)
      }

      return axios(config).then(res => {
        let { status, data } = res || {}
        if (status === 200) {
          return Promise.resolve(data)
        }
        return Promise.reject(res)
      }).catch(err => {
        if (err.response && err.response.status === 401) {
          this.clearAuthInfo()
          let _currentRoute = router.currentRoute
          if (_currentRoute.name !== 'login') {
            router.replace({
              name: 'login',
              query: { redirect: _currentRoute.path }
            })
            // Message({
            //   message: '请登录后操作',
            //   type: 'error'
            // })
          }
        } else {
          console.log('error----', err)
        }
        return Promise.reject(err)
      })
    }
}
